import script from "./EventoContentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoContentCard.vue?vue&type=script&setup=true&lang=js"

import "./EventoContentCard.vue?vue&type=style&index=0&id=01ac2adc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01ac2adc"]])

export default __exports__